const moduleNameKey = "adminPanelPage";

export const adminPanelPageEn = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "Failed to fetch organizations",
  },
};

export const adminPanelPagePtBr = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "Falha ao buscar organizações.",
  },
};

export const adminPanelPageDe = {
  [moduleNameKey]: {
    failedToFetchOrganizations:
      "Organisationen konnten nicht abgerufen werden.",
  },
};

export const adminPanelPageZhHans = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "获取组织失败。",
  },
};

export const adminPanelPageIt = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "Impossibile recuperare le organizzazioni.",
  },
};

export const adminPanelPageEs = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "No se pudieron obtener las organizaciones.",
  },
};

export const adminPanelPageNl = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "Organisaties ophalen is mislukt.",
  },
};

export const adminPanelPageTr = {
  [moduleNameKey]: {
    failedToFetchOrganizations: "Organizasyonlar alınamadı.",
  },
};
